import { FC, useCallback } from 'react';
import { useState } from '@hookstate/core';
import { meta } from '../../stores/backend';
import { closeModal, openModal } from '../../stores/backend/meta';
import { FpeTokenModal as FpeTokenModalComponent } from '../../components/FpeTokenModal';

export const FpeTokenModal: FC = () => {
    const $meta = useState(meta);

    const onClose = useCallback(() => {
        closeModal('fpeToken');
    }, []);

    const onUseNow = useCallback(() => {
        closeModal('fpeToken');
        openModal({ key: 'buy' });
    }, []);

    return (
        <FpeTokenModalComponent
            isOpen={$meta.modals.fpeToken.value}
            onClose={onClose}
            onUseNow={onUseNow}
            onSaveLater={onClose}
        />
    );
};
